module.exports = __webpack_public_path__ + "media/auto_history/dodanie_wspolwlasciciela-blue-07a7245b.svg";